/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_BackInputs */

const en_settings_billing_cancel_back = /** @type {(inputs: Settings_Billing_Cancel_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep subscription`)
};

/**
* | output |
* | --- |
* | "Keep subscription" |
*
* @param {Settings_Billing_Cancel_BackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_back = /** @type {((inputs?: Settings_Billing_Cancel_BackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_BackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_cancel_back(inputs)
});
export { settings_billing_cancel_back as "settings.billing.cancel_back" }